import React from 'react';
import { cn } from '@ideoz/ui';
import { PillOptionGroup } from './PillOptionGroup';

export type PatternGroupProps<T extends string> = {
  label: string;
  options: Array<{ value: T; label: string }>;
  value?: T;
  onChange: (value: T) => void;
  className?: string;
};

export function PatternGroup<T extends string>({
  label,
  options,
  value,
  onChange,
  className,
}: PatternGroupProps<T>): JSX.Element {
  return (
    <div
      className={cn(
        'rounded-lg border border-gray-100 bg-gray-50/60 px-3 py-3 dark:border-gray-800 dark:bg-gray-800/30',
        className,
      )}
    >
      <p className="mb-2 text-sm font-semibold text-primary-800 dark:text-primary-200">{label}</p>
      <PillOptionGroup options={options} value={value} onChange={onChange} />
    </div>
  );
}

export default PatternGroup;
